export default "__VITE_ASSET__CCxpRKIk__"